import type { User } from "@/context/UserProvider";

/** Discover tier: grant_access (legacy Finder) or grant_suite (full product). */
export function userHasGrantDiscover(user: User | null | undefined): boolean {
  if (!user) return false;
  return Boolean(user.grant_discover ?? (user.grant_access || user.grant_suite));
}

/** Track/pipeline tier: grant_suite only. */
export function userHasGrantSuite(user: User | null | undefined): boolean {
  return Boolean(user?.grant_suite);
}

/** Outside collaborator: view-only, grant surface only (ENG-1820). */
export function userIsOutsideUser(user: User | null | undefined): boolean {
  return Boolean(user?.outside_user);
}

/**
 * Runs some team's grant program (ENG-1838). Gates whether the Team Manager
 * area is offered at all; the backend still gates every action in it against
 * the workspace team, so this never stands in for authorization. Outside
 * collaborators are excluded here, not at call sites: admin surfaces are for
 * team members, and every future caller inherits that.
 */
export function userIsGrantTeamManager(user: User | null | undefined): boolean {
  return Boolean(user?.grant_team_manager) && !userIsOutsideUser(user);
}

/** Grant-only app shell applies (outside user + feature flag). */
export function userHasOutsideShell(user: User | null | undefined): boolean {
  return Boolean(user?.outside_user_shell);
}
